import { render, staticRenderFns } from "./LfMenu.vue?vue&type=template&id=23c768ae&scoped=true&"
import script from "./LfMenu.vue?vue&type=script&lang=js&"
export * from "./LfMenu.vue?vue&type=script&lang=js&"
import style0 from "./LfMenu.vue?vue&type=style&index=0&id=23c768ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c768ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c768ae')) {
      api.createRecord('23c768ae', component.options)
    } else {
      api.reload('23c768ae', component.options)
    }
    module.hot.accept("./LfMenu.vue?vue&type=template&id=23c768ae&scoped=true&", function () {
      api.rerender('23c768ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LfMenu.vue"
export default component.exports